module.exports = __webpack_public_path__ + "img/icon-vehicle-type-l1e.f1b242c8.svg";